/* eslint-disable react-hooks/exhaustive-deps */

import React, { ReactElement, useEffect, useState } from 'react'
import moment from 'moment'
import { map, isEmpty } from 'lodash'
import Fade from 'react-reveal/Fade'
import {
  CertificationCard as StyledCertificationCard,
  StyledButton,
  RightDropSection,
  CertificationCardMatrix as StyledCertificationCardMatrix,
  TrainingsDrop,
  DropDownIcon,
  StyledImage,
  EmptyCertifCard,
  CertificationsContent,
  StyledText,
  FadeDiv,
} from './styled-components'
import { Certification } from '../../types/certification'
import Text from '../text'
import Icon from '../icon'
import Button from '../button'
import { useConnectedUserContext } from '../../contexts/connected-user'
import DownloadPdf from '../../constants/pdf-generator/download-pdf'
import { User } from '../../types/user'
import { TrainingGroup } from '../../types/training'

interface CertificationCardProps {
  trainingsGroup: TrainingGroup
  DownloadStatus: (
    text: string,
    status: 'success' | 'pending' | 'error'
  ) => void
}

const CertificationCard = ({
  DownloadStatus,
  trainingsGroup,
}: CertificationCardProps): ReactElement => {
  const { connectedUser } = useConnectedUserContext()

  const [certifications, setCertifications] = useState<Certification[]>([])
  const [showCertifications, setShowCertifications] = useState(false)

  // Récupère les certifs du user qui appartiennent à ce groupe
  useEffect(() => {
    if (!connectedUser?.certifications?.length) return
    const inGroup: Certification[] = []
    connectedUser.certifications.forEach((cert) => {
      const found = trainingsGroup.trainings.find(
        (t) => (t as unknown as string) === cert.training.id
      )
      if (found) inGroup.push(cert)
    })
    setCertifications(inGroup)
  }, [connectedUser?.certifications, trainingsGroup.trainings])

  // Handler download (ne retourne rien)
  const handleDownload = (certId?: string) => {
    if (!certId) return
    // eslint-disable-next-line
    console.log('[Certif] click bouton', {
      cert: certId,
      usr: connectedUser as User,
    })
    // on n'attend pas la Promise -> on respecte la signature () => void
    DownloadPdf(DownloadStatus, certId, connectedUser as User)
  }

  return (
    <StyledCertificationCardMatrix key={trainingsGroup.id}>
      <TrainingsDrop>
        <RightDropSection>
          <DropDownIcon
            onClick={() => setShowCertifications(!showCertifications)}
            isOpen={showCertifications}
          >
            <Icon name="fe:arrow-down" color="grey" width={30} height={30} />
          </DropDownIcon>
          <StyledText>{trainingsGroup.title}</StyledText>
        </RightDropSection>
        <StyledImage src={trainingsGroup.imageUrl} />
      </TrainingsDrop>

      <CertificationsContent>
        <Fade distance="20px" top when={showCertifications}>
          <FadeDiv showCertifications={showCertifications}>
            {isEmpty(certifications) ? (
              <EmptyCertifCard>
                <Text size="medium">لم تتحصل على شهادة بعد</Text>
              </EmptyCertifCard>
            ) : (
              map(certifications, (certification: Certification) => (
                // ⛔️ plus d'onClick sur la carte entière pour éviter la propagation
                <StyledCertificationCard key={certification.id}>
                  <Text color="grey">
                    {moment(certification.date).format('L')}
                  </Text>
                  <Text>{certification.training.title}</Text>

                  <StyledButton>
                    <Button
                      color="darkRed"
                      // important: ne retourne rien, pas de paramètre event
                      // si ton <Button> supporte `type`, tu peux ajouter type="button"
                      onClick={() => handleDownload(certification.id)}
                    >
                      <Icon
                        name="bi:arrow-left"
                        color="white"
                        width={30}
                        height={30}
                      />
                    </Button>
                  </StyledButton>
                </StyledCertificationCard>
              ))
            )}
          </FadeDiv>
        </Fade>
      </CertificationsContent>
    </StyledCertificationCardMatrix>
  )
}

export default CertificationCard
